const storage = {
  keys: {
    filter: 'filter',
    bubble: 'bubbleId'
  },
  get(name) {
    return window.localStorage.getItem(name)
  },
  set(key, value) {
    window.localStorage.setItem(key, value)
  }
}

export default storage
